module.exports = __webpack_public_path__ + "static/qr-code-phone-3c1c7eabb07eccaef193dd7054764e6a.jpg";